export default __webpack_public_path__ + "618d8a15255a2a0e76a2703e0748b2e8.png";